import { ChevronRight } from '@atom-learning/icons'
import * as React from 'react'

import { styled } from '~/styled'

import { ActionIcon } from '../action-icon/ActionIcon'
import { Icon } from '../icon/Icon'
import { usePagination } from './usePagination'

const StyledActionIcon = styled(ActionIcon, {
  base: ['ml-1', 'disabled:opacity-30']
})

export const PaginationNextButton = (
  props: Partial<React.ComponentProps<typeof StyledActionIcon>>
) => {
  const { goToNextPage, labels, nextAvailablePage } = usePagination()

  const isDisabled = !nextAvailablePage

  return (
    <StyledActionIcon
      hasTooltip={false}
      size="md"
      theme="neutral"
      onClick={goToNextPage}
      disabled={isDisabled}
      {...props}
      label={labels?.nextPageButtonLabel || 'Next page'}
    >
      <Icon is={ChevronRight} />
    </StyledActionIcon>
  )
}
